import firebase from "firebase";
import "firebase/firestore";
// import "firebase/messaging";

const config = {
  apiKey: "AIzaSyAb-78uKRAcrUn75WCSbumI8btVCEnaSoU",
  authDomain: "beyla-1.firebaseapp.com",
  databaseURL: "https://beyla-1.firebaseio.com",
  projectId: "beyla-1",
  storageBucket: "beyla-1.appspot.com",
  messagingSenderId: "1091719587345",
  appId: "1:1091719587345:web:248130fc662a8f15",
  measurementId: "G-B6J0XEECK0"
};
const firebaseApp = firebase.initializeApp(config);

// firebase
//   .auth()
//   .signInAnonymously()
//   .catch(() => {});

export const firestore = firebaseApp.firestore();
export const firebaseConfig = config;
// export const messaging = firebase.messaging();

export default firestore;
